export default "__VITE_ASSET__aVE1pWVJ__"